// src/app/shared/components/update-banner/update-banner.component.ts
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppUpdateService } from '../../../core/services/app-update.service';

@Component({
    selector: 'app-update-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './update-banner.component.html',
    styleUrl: './update-banner.component.scss'
})
export class UpdateBannerComponent {
    readonly updateService = inject(AppUpdateService);
}
